import React from "react";
import { Alert } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import DeletionDialog from "../../../library/Dialog/DeletionDialog";

/**
 * Bulk delete confirmations for disclosures (layout aligned with PatchingTemplateDeleteDialog).
 */
const DisclosureBulkDeleteDialog = ({
  bulkDeleteIds,
  setBulkDeleteIds,
  deleting,
  confirmDelete,
  previewTitles = [],
}) => {
  const open = Boolean(bulkDeleteIds?.length);
  const count = bulkDeleteIds?.length ?? 0;

  const close = () => {
    if (!deleting) setBulkDeleteIds(null);
  };

  return (
    <DeletionDialog
      open={open}
      onClose={close}
      title='Delete disclosures'
      count={count}
      itemSingular='disclosure'
      itemPlural='disclosures'
      previewTitles={previewTitles}
      deleting={deleting}
      onConfirm={confirmDelete}
    />
  );
};

export default DisclosureBulkDeleteDialog;
